import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Auth from '@/components/Auth'
import download from '@/components/download'
Vue.use(Router)
import firebase from 'firebase'
var router = new Router({
  routes: [{
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/download',
      name: 'download',
      component: download,
      meta: {
        requiresAuth: true
      }
    },
  ]
})



// router.beforeEach((to, from, next) => {
//   let currentUser = firebase.auth().currentUser;
//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//   // nprogress.start()
//   // nprogress.set(0.1)
//   if (requiresAuth && !currentUser) next('/')
//   else if (!requiresAuth && currentUser) next('/auth')
//   else next()
// })

// router.afterEach(() => {
//   // setTimeout(() => NProgress.done(), 500)
// })


export default router



// WEBPACK FOOTER //
// ./src/router/index.js